import { MAP_FULL, MAP_HYBRID } from '../../model/query/mapViewOptions';
import { RELEVANCY_SORT } from '../../model/query/sortOptions';
import { sanitizeLocation } from './sanitize';
import { Selling } from '../../../../shared/model/constants/customerChannels';
import type { BoundingBoxType } from '../../../../shared/model/constants/filterTypes';
import type { PropertyType, SortOptionType } from '../../../../shared/model/tsTypes';

export const convertLocationsToString = (locations?: string[]) => {
  const validLocations = locations?.map(sanitizeLocation).filter(Boolean);
  if (!validLocations || validLocations.length < 2) return undefined;

  return validLocations.join(',');
};

export const convertCurrentLocationToQueryObj = (location?: string[]) => {
  if (!location || location.length === 0) return undefined;

  return {
    where: location.join(','),
    currentLocation: true,
  };
};

export const convertSortToString = (sortObject?: SortOptionType) => {
  if (!sortObject) return undefined;

  return sortObject !== RELEVANCY_SORT ? sortObject.value : undefined;
};

export const convertKeywordsToQueryString = (keywords?: string) => {
  if (!keywords || keywords.length === 0) return undefined;

  return keywords.replace(/\*+/g, '').replace(/ +/g, '+');
};

export const validatedMapView = (mapView?: string) =>
  [MAP_FULL, MAP_HYBRID].find((validView) => validView === mapView);

export const validatedPage = (page?: number) => (page && page > 1 ? page : undefined);

export const convertPropertyTypeUrlsToQueryString = (propertyTypeUrls?: string[]) => {
  if (!propertyTypeUrls || propertyTypeUrls.length < 2) return undefined;

  return propertyTypeUrls.join(',');
};

export const convertCustomerPropertyTypesToQueryString = (propertyTypes?: PropertyType[]) => {
  if (!propertyTypes || !propertyTypes.length) return undefined;

  return propertyTypes.map((p) => p.agencyUrl).join(',');
};

export const convertBoundingBoxToString = (boundingBox?: BoundingBoxType) => {
  if (!boundingBox) {
    return undefined;
  }
  const { northEastLatitude, northEastLongitude, southWestLatitude, southWestLongitude } =
    boundingBox;

  return `${northEastLatitude},${northEastLongitude},${southWestLatitude},${southWestLongitude}`;
};

export const validatedAgencyChannel = (channel?: string) => {
  if (!channel) return undefined;

  return channel !== Selling.url ? channel : undefined;
};
